// extracted by mini-css-extract-plugin
export default {"quota":"quota--QCij8","content":"content--sY3xR","noRequest":"noRequest--OdxJt","deadline":"deadline--Z9PXs"};